var _rect, _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 4,
    fill: "#E6F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_89501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1224 18.3636L21.5012 24.9849L18.0163 21.5L12.7891 26.7273M28.1224 18.3636H23.9406M28.1224 18.3636V22.5455",
    stroke: "#008080",
    strokeWidth: 1.60465,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 10.6977,
    stroke: "#008080",
    strokeWidth: 1.60465
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_89501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7273,
    height: 16.7273,
    fill: "white",
    transform: "translate(12.0938 14.1819)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherServices);
export default __webpack_public_path__ + "static/media/other_services.b224ee17b8acecb5af4e5cc9555eed28.svg";
export { ForwardRef as ReactComponent };